<template>
    <span class="da-tooltip-span" :class="tooltipCssClass" :title="tooltipText">
        <svg v-if="iconVersion=='2'" width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.001 7.26953C14.001 11.1355 10.867 14.2695 7.00098 14.2695C3.13498 14.2695 0.000976562 11.1355 0.000976562 7.26953C0.000976562 3.40354 3.13498 0.269531 7.00098 0.269531C10.867 0.269531 14.001 3.40354 14.001 7.26953ZM6.12598 11.3139C6.12598 10.8307 6.51773 10.4389 7.00098 10.4389C7.48423 10.4389 7.87598 10.8307 7.87598 11.3139C7.87598 11.7972 7.48423 12.1889 7.00098 12.1889C6.51773 12.1889 6.12598 11.7972 6.12598 11.3139ZM6.96971 4.13277C7.41069 4.1158 7.7454 4.24731 7.96337 4.44354C8.17706 4.63592 8.32393 4.93036 8.32393 5.33793C8.32393 5.67662 8.24798 5.84286 8.14051 5.98345C8.0177 6.14409 7.84904 6.2832 7.56243 6.51959C7.51541 6.55836 7.46514 6.59983 7.41146 6.64436L7.39767 6.65467C7.37907 6.66872 7.35352 6.68837 7.32293 6.71277C7.26224 6.76116 7.17923 6.83022 7.09028 6.91292C6.93654 7.05586 6.67404 7.32071 6.55203 7.63649C6.47559 7.83432 6.42438 8.02698 6.39252 8.16595C6.37632 8.23658 6.36451 8.29609 6.35658 8.339C6.3526 8.36052 6.34957 8.37801 6.34743 8.39083L6.34487 8.4065L6.34407 8.41158L6.34379 8.41341L6.34363 8.41446C6.34362 8.41453 6.34358 8.41474 6.96151 8.50848L6.34363 8.41446C6.29186 8.75573 6.52651 9.07464 6.86778 9.12641C7.20894 9.17816 7.52747 8.94364 7.57939 8.60255C7.57938 8.60262 7.57941 8.60248 7.57939 8.60255L7.58033 8.5969C7.58137 8.59067 7.58316 8.58023 7.58576 8.56622C7.59096 8.53808 7.59924 8.49616 7.61091 8.44527C7.63477 8.34121 7.67031 8.21051 7.71802 8.08701C7.7187 8.08557 7.73282 8.05546 7.77937 7.99817C7.82363 7.9437 7.88028 7.88522 7.94143 7.82837C8.00157 7.77245 8.0594 7.72426 8.10227 7.69007C8.12346 7.67318 8.14037 7.6602 8.15129 7.65195L8.1628 7.64334L8.16387 7.64254L8.1807 7.63037L8.19681 7.61699C8.2423 7.57922 8.28891 7.54104 8.33614 7.50236C8.61486 7.27411 8.91544 7.02796 9.13359 6.74259C9.42594 6.36015 9.57393 5.91938 9.57393 5.33793C9.57393 4.60598 9.29815 3.96328 8.79971 3.51455C8.30555 3.06967 7.63862 2.85609 6.92162 2.8837C5.91633 2.9224 5.25217 3.34879 4.86594 3.94193C4.50552 4.49543 4.43378 5.12209 4.42804 5.51819C4.42304 5.86333 4.69878 6.14718 5.04393 6.15218C5.38907 6.15718 5.67291 5.88144 5.67791 5.5363C5.68216 5.24338 5.73893 4.89203 5.91344 4.62402C6.06214 4.39566 6.33934 4.15704 6.96971 4.13277Z" fill="#0069BA" />
        </svg>
        <!-- <svg v-else-if="3" class="info-icon svg-inline--fa fa-info-circle fa-w-16" style="width:1em; height:1em; font-size: 10px; vertical-align: 0.3em" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="info-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path fill="white" d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z">
            </path>
        </svg> -->
        <svg v-else class="info-icon svg-inline--fa fa-info-circle fa-w-16" v-bind:style="iconVersion == '3' ? 'width:1em; height:1em; font-size: 10px; vertical-align: 0.3em' : 'width:1em; height:1em; vertical-align: -0.125em'" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="info-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path v-bind:fill="iconVersion == '3' ? 'white' : 'currentColor'" d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z">
            </path>
        </svg>    
    </span>
</template>
<script lang="ts">
import Vue, { defineComponent } from 'vue'
export default defineComponent({
    components: {},
    props: {
        tooltipCssClass: String,
        tooltipText: String,
        iconVersion: String
    },
    mounted() {
        (jQuery(".da-tooltip-span") as any).tooltip({
            template: '<div class="tooltip da-tooltip da-tooltip-white" role="tooltip"><div class="arrow tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
            container: 'body',
            placement: 'bottom',
            html: true
        });
    }      
})
</script>
<style>
    .tooltip.da-tooltip.show {opacity: 1;}
    .da-tooltip-white > .tooltip-inner {background-color: #fff !important; color: #555; font-size: 11px; text-align: left; border:1px solid #ccc; font-style: italic;}
    .info-icon {color: #c6c4c7; }

    /* Bootstrap 3 tooltip styles */
    .da-tooltip > .tooltip-arrow {
        position: absolute;
        display: block;
        width: .8rem;
        height: .4rem;
        border:none !important;
    }
    .tooltip.bottom {
        padding: .4rem 0;
    }

    /* Bootstrap 3 styles */
    .da-tooltip > .tooltip-arrow::before,
    .da-tooltip > .tooltip-arrow::after {
        content: "";
        position: absolute;
        bottom: 0;
        border-width: 0 .4rem .4rem;
        border-color: transparent;
        border-style: solid;
    }

    /* Bootstrap 3 and 4 tooltip styles */
    .da-tooltip > .tooltip-arrow::before {
        border-bottom-color: #ccc !important;
        border-top-color: #ccc !important;
    }
    .da-tooltip > .tooltip-arrow:after {
        transform: translateY(3px);
        border-bottom-color: #fff !important;
        border-top-color: #fff !important;
    }

    /* Bootstrap 4 tooltip styles */
    .bs-tooltip-top > .arrow::before,
    .bs-tooltip-top > .arrow::after {
        border-width: .4rem .4rem 0 !important;
    }
    .bs-tooltip-bottom > .arrow::before,
    .bs-tooltip-bottom > .arrow::after {
        border-width: 0 .4rem .4rem !important;
    }
    .bs-tooltip-top > .arrow::after {
        transform: translateY(-3px);
    }
</style>